export default [
  {
    NAME: 'a13_17',
    MIN: 13,
    MAX: 17,
  },
  {
    NAME: 'a18_24',
    MIN: 18,
    MAX: 24,
  },
  {
    NAME: 'a25_34',
    MIN: 25,
    MAX: 34,
  },
  {
    NAME: 'a35_44',
    MIN: 35,
    MAX: 44,
  },
  {
    NAME: 'a45_54',
    MIN: 45,
    MAX: 54,
  },
  {
    NAME: 'a55_64',
    MIN: 55,
    MAX: 64,
  },
  {
    NAME: 'a65_99',
    MIN: 65,
    MAX: 99,
  },
]
